// src/services/ConversationService.ts
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  where,
  query,
  Timestamp,
  orderBy,
} from "firebase/firestore";
import { Conversation, Message } from "@visitproof/types";
import { db } from "../firebase";
import { clean } from "../utils/utils";

const conversationCollectionRef = collection(db, "conversations");
const messageCollectionRef = collection(db, "messages");

export const ConversationService = {
  async getConversation(conversationId: string): Promise<Conversation | null> {
    console.log("conversationId", conversationId);
    const conversationDoc = await getDoc(
      doc(conversationCollectionRef, conversationId),
    );
    if (conversationDoc.exists()) {
      return {
        id: conversationDoc.id,
        ...conversationDoc.data(),
      } as Conversation;
    }
    return null;
  },

  async getAllConversations(
    accountId: string,
    status: "draft" | "open" | "paid" | "uncollectible" | "all",
  ): Promise<Conversation[]> {
    try {
      if (status === "all") {
        const conversationSnapshot = await getDocs(
          query(
            conversationCollectionRef,
            where("accountId", "==", accountId),
            orderBy("createdAt", "desc"),
          ),
        );
        return conversationSnapshot.docs.map(
          (doc) => ({ id: doc.id, ...doc.data() }) as Conversation,
        );
      }
      const conversationSnapshot = await getDocs(
        query(
          conversationCollectionRef,
          where("accountId", "==", accountId),
          where("status", "==", status),
          orderBy("createdAt", "desc"),
        ),
      );
      return conversationSnapshot.docs.map(
        (doc) => ({ id: doc.id, ...doc.data() }) as Conversation,
      );
    } catch (err) {
      console.error(err);
      return [];
    }
  },

  async getMessagesForConversation(conversationId: string): Promise<Message[]> {
    const messageSnapshot = await getDocs(
      query(
        messageCollectionRef,
        where("conversationId", "==", conversationId),
      ),
    );
    return messageSnapshot.docs.map(
      (doc) => ({ id: doc.id, ...doc.data() }) as Message,
    );
  },

  async updateConversation(
    conversationId: string,
    updatedData: Partial<Omit<Conversation, "id" | "createdAt">>,
  ): Promise<void> {
    const conversationDocRef = doc(conversationCollectionRef, conversationId);
    await updateDoc(conversationDocRef, clean({
      ...updatedData,
      updatedAt: Timestamp.now(),
    }));
  },

  async deleteConversation(conversationId: string): Promise<void> {
    const conversationDocRef = doc(conversationCollectionRef, conversationId);
    await deleteDoc(conversationDocRef);
  },
};
